<div class="container-grid">

    <div class="gallery-grid">
        <div class="gallery-card add-card">
            <div>
                <app-cosentino-svg class="icon" [svgName]="'image'" [size]="48"></app-cosentino-svg>

                <h3 class="titleGalleries">{{ 'my_galleries.mygalleriesnew2_add_new_gallery' | translate }}</h3>
                <p class="contentResume typography-body-l-regular">{{ 'my-galleries.content-resume' | translate }}</p>
            </div>

            <div>
                <div>
                    <app-button [primary]="true" [block]="true" (onClick)="goToNew()" size="L" [gtmLabel]="'button_add-new-gallery'"><span class="typography-body-m-medium oneLine">{{ 'my_galleries.mygalleriesnew2_add_new_gallery' | translate }}</span></app-button>
                </div>
            </div>
        </div>

        <app-gallery-item
            *ngFor="let gallery of galleries"
            [gallery]="gallery"
            [gtmLabel]="formatStatusForGTM(gallery.status)"
            (click)="goToEdit(gallery)"
        />
    </div>
</div>
